import { LAYOUT } from './constants'

export function PageFooter({ pageNumber, isEven, bookLabel, footerTop, bleedPx = 0 }: {
  pageNumber: number
  isEven: boolean
  bookLabel: string
  footerTop: number
  bleedPx?: number
}) {
  return (
    <div
      className="absolute"
      style={{
        top: footerTop + bleedPx,
        ...(isEven ? { left: LAYOUT.footer.sideMargin + bleedPx } : { right: LAYOUT.footer.sideMargin + bleedPx }),
      }}
    >
      <div className="flex items-center gap-[8px]">
        <span style={{ fontSize: 16, fontWeight: 600, color: '#000', letterSpacing: '-0.096px' }}>
          {pageNumber}
        </span>
        {isEven && bookLabel && (
          <>
            <div style={{ width: 1, height: 10, backgroundColor: '#999' }} />
            <span style={{ fontSize: 14, color: '#000', letterSpacing: '-0.084px' }}>
              {bookLabel}
            </span>
          </>
        )}
      </div>
    </div>
  )
}
